import { HttpClient } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { catchError, map, shareReplay } from "rxjs/operators";
import { BASE_API_URL } from "../../core/environment.tokens";
import { SELECT_ALL_LIMIT_HIGH_VOLUME, SELECT_ALL_LIMIT_LEGACY } from "./bulk-selection-limit";

/** The one field this service reads from GET bulkactionjob/settings. */
interface IChaseQuerySelectAllSettings {
  isChaseQuerySelectAll50kEnabled?: boolean;
}

/** AD-1961: the Chase Query select-all cap, from the server flag `EnableChaseQuerySelectAll50k`. */
@Injectable({
  providedIn: "root",
})
export class BulkSelectionLimitService {
  /** 5,000 or 50,000, cached for the session. Falls back to 5,000 on error. */
  readonly selectAllLimit$: Observable<number>;

  constructor(
    @Inject(BASE_API_URL)
    private readonly baseApiUrl: string,
    private readonly http: HttpClient
  ) {
    this.selectAllLimit$ = this.http.get<IChaseQuerySelectAllSettings>(`${this.baseApiUrl}bulkactionjob/settings`)
      .pipe(
        map(settings => settings?.isChaseQuerySelectAll50kEnabled === true
          ? SELECT_ALL_LIMIT_HIGH_VOLUME
          : SELECT_ALL_LIMIT_LEGACY),
        catchError(() => of(SELECT_ALL_LIMIT_LEGACY)),
        shareReplay(1)
      );
  }
}
